(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3889],{

/***/ 26447:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astro",
      function () {
        return __webpack_require__(52237);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40624:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/icon-right-arrow.e724f296.svg","height":25,"width":25});

/***/ }),

/***/ 25889:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/line-gray.2a41f7c7.png","height":8,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAD1BMVEV7d3f/FC8A7s5MaXH/GDKI9FCUAAAABXRSTlNhbhAApp5TfdEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAARSURBVAiZY2BgYGJkYWZgAAAAMwALvlsjkAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 58488:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/white-line.61493d09.png","height":8,"width":64,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAAD1BMVEX/+/z/DSj///9MaXH/FjFljS8sAAAABXRSTlNhbhAApp5TfdEAAAAJcEhZcwAACxMAAAsTAQCanBgAAAARSURBVAiZY2BgYGJkYWZgAAAAMwALvlsjkAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 52237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ astro; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/free-mode/free-mode.min.css
var free_mode_min = __webpack_require__(30706);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/thumbs/thumbs.min.css
var thumbs_min = __webpack_require__(75083);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/assets/images/Astro-Banner.jpg
/* harmony default export */ var Astro_Banner = ({"src":"/_next/static/media/Astro-Banner.8942e35b.jpg","height":670,"width":1920,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAACAgMBAQAAAAAAAAAAAAABAgADBBESEyL/xAAVAQEBAAAAAAAAAAAAAAAAAAABBP/EABkRAAIDAQAAAAAAAAAAAAAAAAECABEhUf/aAAwDAQACEQMRAD8AntljY+BT5aXtem+QdkqYiJS4sC+RZmGAz//Z"});
;// CONCATENATED MODULE: ./src/assets/images/Daily-Horoscope.jpg
/* harmony default export */ var Daily_Horoscope = ({"src":"/_next/static/media/Daily-Horoscope.32f40dfc.jpg","height":343,"width":514,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAABAwMFAQAAAAAAAAAAAAABAAIEAwURBhIhMUGh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgT/xAAYEQADAQEAAAAAAAAAAAAAAAAAAQIDEf/aAAwDAQACEQMRAD8AhIV2tjNP148uFVfU2kNcwt965IyMfURFTpT6CUj/2Q=="});
// EXTERNAL MODULE: ./src/assets/images/icon-right-arrow.svg
var icon_right_arrow = __webpack_require__(40624);
;// CONCATENATED MODULE: ./src/assets/images/Kudili.jpg
/* harmony default export */ var Kudili = ({"src":"/_next/static/media/Kudili.3406f0c0.jpg","height":343,"width":514,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAfEAAABQQDAAAAAAAAAAAAAAAAAQIDEwQFETEGElH/xAAVAQEBAAAAAAAAAAAAAAAAAAAEBf/EABcRAAMBAAAAAAAAAAAAAAAAAAACIQH/2gAMAwEAAhEDEQA/AItO9ZHuGnaYX5lOZTURp34ZdtZAAAcdrSi65If/2Q=="});
;// CONCATENATED MODULE: ./src/assets/images/Astro-Consultation.jpg
/* harmony default export */ var Astro_Consultation = ({"src":"/_next/static/media/Astro-Consultation.b3f99ac0.jpg","height":343,"width":514,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAeEAABAwQDAAAAAAAAAAAAAAACAAMEAQURIRJhgf/EABUBAQEAAAAAAAAAAAAAAAAAAAAB/8QAFxEBAQEBAAAAAAAAAAAAAAAAAgABEf/aAAwDAQACEQMRAD8AnMaZb3YzrY2dknTKmzcLiNOsbz6iIhOVS3t//9k="});
// EXTERNAL MODULE: ./src/assets/images/line-gray.png
var line_gray = __webpack_require__(25889);
// EXTERNAL MODULE: ./src/assets/images/white-line.png
var white_line = __webpack_require__(58488);
;// CONCATENATED MODULE: ./src/assets/images/Why-choose-senco-astro.jpg
/* harmony default export */ var Why_choose_senco_astro = ({"src":"/_next/static/media/Why-choose-senco-astro.8e92ff6e.jpg","height":480,"width":572,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAHAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAACAgEFAAAAAAAAAAAAAAAAAQIRBAUSEyHx/8QAFAEBAAAAAAAAAAAAAAAAAAAABf/EABgRAAIDAAAAAAAAAAAAAAAAAAACEUFx/9oADAMBAAIRAxEAPwC1eRJ67GDaUODeqvtegAIkTesP/9k="});
;// CONCATENATED MODULE: ./src/assets/images/astro-main-1.png
/* harmony default export */ var astro_main_1 = ({"src":"/_next/static/media/astro-main-1.3f7666c8.png","height":651,"width":568,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAV1BMVEVMaXEqIR54SjDzli9KLB/obSb/1Ubv12z8pzhrSCLVYhg/LySqTB9XQTvBeSx3QhcgHR3ueiwqJCMGDxeLUCgzLSqHRSSrWiYZFRdMLyNTRTpkOyW2lXZfHn4GAAAAGXRSTlMA9/46UUQFAxESDqzichA6rOfTQET9O+jm0oPS8wAAAAlwSFlzAAALEwAACxMBAJqcGAAAADxJREFUCJkFwQcCgCAMALEDgbYu3Fr0/+80AaQaILq07VKw8LUkFHviuYPO9+tHgX71mEG7MXgGkTRMwg9KWgJCuUH2ogAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/images/astro-main-2.png
/* harmony default export */ var astro_main_2 = ({"src":"/_next/static/media/astro-main-2.4efabb0e.png","height":651,"width":575,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAYFBMVEVMaXFxQELQqafZr650KTFwKRmKRyq8XQj9qWf8kir/uELOgCQAAAAfEAAdDw9KOl8NCQCba5/gy855XobVucSARnm9jKpBNFpOMi0qExGTYIlYSW7xxtTWusTmu7qfga2vauZFAAAAGHRSTlMATvFCDRQ6BQoSEjtOreKtdOb+7uc//dQDnhApAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAO0lEQVQImQXBBwKAIAwAsWO2uFBwz///0gQgBgDN1xYThPqdRlA/3esCSeenOAFvX+ugaYf9MCB0/Sj8RFsCNH71Z2IAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/styles/Astro.module.scss
var Astro_module = __webpack_require__(10335);
var Astro_module_default = /*#__PURE__*/__webpack_require__.n(Astro_module);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/layout/layout.tsx + 18 modules
var layout = __webpack_require__(70081);
;// CONCATENATED MODULE: ./src/pages/astro/index.tsx












// import Astrobanner from "@/assets/images/Astro-Banner.jpg.jpg";















swiper_esm/* default.use */.ZP.use([
    swiper_esm/* FreeMode */.Rv,
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Thumbs */.o3
]);
var Astro = function() {
    var ref = (0,react.useState)([]), astro = ref[0], setAstro = ref[1];
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        loadZodiac();
    }, []);
    var loadZodiac = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return http_client/* default.get */.Z.get(endpoints/* default.astro.zodiacList */.Z.astro.zodiacList());
                    case 3:
                        data = _ctx.sent.data;
                        setAstro(data);
                        _ctx.next = 9;
                        break;
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](0);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    7
                ]
            ]);
        }));
        return function loadZodiac() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref1 = (0,react.useState)(null), thumbsSwiper = ref1[0], setThumbsSwiper = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Astro_module_default()).astro_banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: Astro_Banner,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Astro_module_default()).astro_bg,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Astro_module_default()).astro_bg_main,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Astro_module_default()).custom_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: Astro_Consultation,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Astro_module_default()).heading,
                                                    children: "Astro Consultation"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Our astro consultation services are customized to help you gain a deeper understanding of your personal life, health and career."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/astro/astrologers",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Astro_module_default()).more,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Book Now"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: icon_right_arrow/* default */.Z,
                                                                alt: ""
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Astro_module_default()).custom_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: Kudili,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Astro_module_default()).heading,
                                                    children: "Kundli "
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Your Janam Kundli or Life Kushti can be the success tool of your life. We also specialize in Kundli Matching services."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/astro/kundali",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Astro_module_default()).more,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Book Now"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: icon_right_arrow/* default */.Z,
                                                                alt: ""
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-md-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Astro_module_default()).custom_card,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: Daily_Horoscope,
                                                        alt: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Astro_module_default()).heading,
                                                    children: "Daily Horoscope"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Boost your confidence with our Daily Horoscope services based on your zodiac sign. It includes your lucky number and colour as well."
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/astro/horoscope",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Astro_module_default()).more,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "Check Now"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: icon_right_arrow/* default */.Z,
                                                                alt: ""
                                                            }),
                                                            " "
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Astro_module_default()).about_astro,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                                children: "Online Astrological Services"
                                            })
                                        }),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Astro_module_default()).gline,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: line_gray/* default */.Z,
                                        alt: ""
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "row justify-content-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-md-12",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center",
                                                children: "The customized astrological services offered by Senco Gold & Diamonds aim at bringing harmony in one’s life. We have years of experience in guiding people who are wandering without direction and seeking professional guidance. The objective is to help our customers in the best possible way. Daily horoscope services, Kundli services and Astro Consultation services – we offer it all."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center",
                                                children: "We also offer Career and Business Horoscope services that include career analysis, favourable periods for career, career yoga and favourable periods for business. We will also let you know the auspicious periods and favourable Dasa Periods that will help you succeed in your career/business. You can choose from a wide range of time periods for Kundli services."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center text-dark",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                                        children: "A Trusted Name for Astrological Gemstones"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-center",
                                                children: "Discover the world of 100% authentic and certified astrological gemstones at Senco Gold & Diamonds. Our precious gemstones have an alluring splendor and unparalleled hues. Our gemstone experts are equipped with comprehensive knowledge and expertise in the identification, grading, and valuation of gemstones. Visit our stores to discuss your planetary gemstone requirements and choose from a wide range of authentic gemstones."
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Astro_module_default()).about_astro_main,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-6",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (Astro_module_default()).about_astro_main_img,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: Why_choose_senco_astro,
                                                        alt: ""
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-md-6",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (Astro_module_default()).about_astro_main_heading,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                                            children: " Why Choose Senco for Astrological Services?"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                        className: (Astro_module_default()).list,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "A trusted name with years of experience in offering astrological services."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Try to meet and exceed the expectations of our customers."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Continually strive to provide accurate and detailed predictions."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Our astrologers have in-depth and extensive knowledge of the subject."
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: "Let you choose from a wide variety of astrological services at affordable prices."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: (Astro_module_default()).about_astro_main_call,
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/contact-us",
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: (Astro_module_default()).text_hover,
                                                                    children: "Contact Us "
                                                                })
                                                            }),
                                                            " ",
                                                            "to know more about our Astrological Services"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Astro_module_default()).horoscope_bg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Astro_module_default()).horoscope_astro,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (Astro_module_default()).horoscope_astro_head,
                                children: [
                                    "CHECK YOUR ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "HOROSCOPE"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Astro_module_default()).wline,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: white_line/* default */.Z,
                                    alt: ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row justify-content-center mt-4 mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-center",
                                        children: " Life is full of possibilities."
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Astro_module_default()).icon_container,
                                children: !!astro.length && astro.map(function(v) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Astro_module_default()).col,
                                                style: {
                                                    cursor: "pointer"
                                                },
                                                onClick: function() {
                                                    router.push("/astro/horoscope/".concat(v.name));
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (Astro_module_default()).border_full,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (Astro_module_default()).icon_img,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: v.thumbnail_image,
                                                                alt: "",
                                                                height: "200px",
                                                                width: "200px"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            children: [
                                                                v.name,
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " ",
                                                                moment_default()(v.start_date).format("MMMM DD"),
                                                                " -",
                                                                moment_default()(v.end_date).format("MMMM DD")
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Astro_module_default()).horoscope_bg_row,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row align-items-center justify-content-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Astro_module_default()).horoscope_bg_row_img,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: astro_main_1,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Astro_module_default()).horoscope_bg_row_img_heading,
                                        children: "Astro Consultation"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/astro/astrologers",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Astro_module_default()).horoscope_bg_row_button,
                                            children: "Book Now"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Astro_module_default()).horoscope_bg_row_img,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: astro_main_2,
                                            alt: ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Astro_module_default()).horoscope_bg_row_img_heading,
                                        children: "Get Kundli"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/astro/kundali",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (Astro_module_default()).horoscope_bg_row_button,
                                            children: "Book Now"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var astro = (Astro);


/***/ }),

/***/ 10335:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"astro_banner":"Astro_astro_banner__sDO2M","astro_banner_text":"Astro_astro_banner_text__6DTk4","astro_banner_main":"Astro_astro_banner_main__o0hbF","astro_banner_main_text":"Astro_astro_banner_main_text__x8uh5","astro_bg":"Astro_astro_bg__5NVPX","astro_bg_main":"Astro_astro_bg_main__W1LDZ","custom_card":"Astro_custom_card__3YSWN","heading":"Astro_heading__TFh8B","more":"Astro_more__knWmG","about_astro":"Astro_about_astro__TMR3Z","about_astro_main":"Astro_about_astro_main__6TDgV","about_astro_main_img":"Astro_about_astro_main_img__n86o5","about_astro_main_heading":"Astro_about_astro_main_heading__MV3Bm","about_astro_main_call":"Astro_about_astro_main_call__x6ZEc","call_number":"Astro_call_number__W8kJm","horoscope_bg":"Astro_horoscope_bg__s1cC8","horoscope_astro_head":"Astro_horoscope_astro_head__5r0tj","horoscope_bg_row":"Astro_horoscope_bg_row__0OLXN","horoscope_bg_row_img":"Astro_horoscope_bg_row_img__Tcq6K","horoscope_bg_row_img_heading":"Astro_horoscope_bg_row_img_heading__wLgyr","horoscope_bg_row_button":"Astro_horoscope_bg_row_button__Ba79J","horoscope_bg_row_form":"Astro_horoscope_bg_row_form__aVmQu","horoscope_bg_row_form_head":"Astro_horoscope_bg_row_form_head__lABJU","horoscope_bg_row_form_body":"Astro_horoscope_bg_row_form_body__AuMuo","form_control":"Astro_form_control__DExHL","red_button":"Astro_red_button__uwOGN","horoscope_bg_row_w":"Astro_horoscope_bg_row_w__QXmKl","horoscope_bg_dark":"Astro_horoscope_bg_dark__v1OLp","wline":"Astro_wline__Sbx21","gline":"Astro_gline__YrthE","new_row_st":"Astro_new_row_st__wpP8K","new_row_st_main":"Astro_new_row_st_main__UGOWU","new_row_st_main_text":"Astro_new_row_st_main_text__9vTKn","icon_container":"Astro_icon_container__HgDxd","col":"Astro_col__i7eey","border_full":"Astro_border_full__GUQ2b","icon_img":"Astro_icon_img__pZd8A","list":"Astro_list__DCkVJ","text_hover":"Astro_text_hover__dPnZt","custom_font":"Astro_custom_font__0jTSV"};

/***/ }),

/***/ 30706:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 75083:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Accordion; }
});

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/uncontrollable/lib/esm/index.js + 4 modules
var esm = __webpack_require__(47150);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Collapse.js + 1 modules
var Collapse = __webpack_require__(16518);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionContext.js

function isAccordionItemSelected(activeEventKey, eventKey) {
  return Array.isArray(activeEventKey) ? activeEventKey.includes(eventKey) : activeEventKey === eventKey;
}
const context = /*#__PURE__*/react.createContext({});
context.displayName = 'AccordionContext';
/* harmony default export */ var AccordionContext = (context);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionCollapse.js








/**
 * This component accepts all of [`Collapse`'s props](/utilities/transitions/#collapse-props).
 */
const AccordionCollapse = /*#__PURE__*/react.forwardRef(({
  as: Component = 'div',
  bsPrefix,
  className,
  children,
  eventKey,
  ...props
}, ref) => {
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-collapse');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse/* default */.Z, {
    ref: ref,
    in: isAccordionItemSelected(activeEventKey, eventKey),
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      children: react.Children.only(children)
    })
  });
});
AccordionCollapse.displayName = 'AccordionCollapse';
/* harmony default export */ var esm_AccordionCollapse = (AccordionCollapse);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItemContext.js

const AccordionItemContext_context = /*#__PURE__*/react.createContext({
  eventKey: ''
});
AccordionItemContext_context.displayName = 'AccordionItemContext';
/* harmony default export */ var AccordionItemContext = (AccordionItemContext_context);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionBody.js







const AccordionBody = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-body');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionCollapse, {
    eventKey: eventKey,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionBody.displayName = 'AccordionBody';
/* harmony default export */ var esm_AccordionBody = (AccordionBody);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionButton.js







function useAccordionButton(eventKey, onClick) {
  const {
    activeEventKey,
    onSelect,
    alwaysOpen
  } = (0,react.useContext)(AccordionContext);
  return e => {
    /*
      Compare the event key in context with the given event key.
      If they are the same, then collapse the component.
    */
    let eventKeyPassed = eventKey === activeEventKey ? null : eventKey;

    if (alwaysOpen) {
      if (Array.isArray(activeEventKey)) {
        if (activeEventKey.includes(eventKey)) {
          eventKeyPassed = activeEventKey.filter(k => k !== eventKey);
        } else {
          eventKeyPassed = [...activeEventKey, eventKey];
        }
      } else {
        // activeEventKey is undefined.
        eventKeyPassed = [eventKey];
      }
    }

    onSelect == null ? void 0 : onSelect(eventKeyPassed, e);
    onClick == null ? void 0 : onClick(e);
  };
}
const AccordionButton = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'button',
  bsPrefix,
  className,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-button');
  const {
    eventKey
  } = (0,react.useContext)(AccordionItemContext);
  const accordionOnClick = useAccordionButton(eventKey, onClick);
  const {
    activeEventKey
  } = (0,react.useContext)(AccordionContext);

  if (Component === 'button') {
    props.type = 'button';
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    onClick: accordionOnClick,
    ...props,
    "aria-expanded": eventKey === activeEventKey,
    className: classnames_default()(className, bsPrefix, !isAccordionItemSelected(activeEventKey, eventKey) && 'collapsed')
  });
});
AccordionButton.displayName = 'AccordionButton';
/* harmony default export */ var esm_AccordionButton = (AccordionButton);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionHeader.js





const AccordionHeader = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'h2',
  bsPrefix,
  className,
  children,
  onClick,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-header');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(className, bsPrefix),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(esm_AccordionButton, {
      onClick: onClick,
      children: children
    })
  });
});
AccordionHeader.displayName = 'AccordionHeader';
/* harmony default export */ var esm_AccordionHeader = (AccordionHeader);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/AccordionItem.js






const AccordionItem = /*#__PURE__*/react.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'div',
  bsPrefix,
  className,
  eventKey,
  ...props
}, ref) => {
  bsPrefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion-item');
  const contextValue = (0,react.useMemo)(() => ({
    eventKey
  }), [eventKey]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionItemContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...props,
      className: classnames_default()(className, bsPrefix)
    })
  });
});
AccordionItem.displayName = 'AccordionItem';
/* harmony default export */ var esm_AccordionItem = (AccordionItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Accordion.js












const Accordion = /*#__PURE__*/react.forwardRef((props, ref) => {
  const {
    // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div',
    activeKey,
    bsPrefix,
    className,
    onSelect,
    flush,
    alwaysOpen,
    ...controlledProps
  } = (0,esm/* useUncontrolled */.Ch)(props, {
    activeKey: 'onSelect'
  });
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'accordion');
  const contextValue = (0,react.useMemo)(() => ({
    activeEventKey: activeKey,
    onSelect,
    alwaysOpen
  }), [activeKey, onSelect, alwaysOpen]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionContext.Provider, {
    value: contextValue,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
      ref: ref,
      ...controlledProps,
      className: classnames_default()(className, prefix, flush && `${prefix}-flush`)
    })
  });
});
Accordion.displayName = 'Accordion';
/* harmony default export */ var esm_Accordion = (Object.assign(Accordion, {
  Button: esm_AccordionButton,
  Collapse: esm_AccordionCollapse,
  Item: esm_AccordionItem,
  Header: esm_AccordionHeader,
  Body: esm_AccordionBody
}));

/***/ }),

/***/ 27977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




const defaultProps = {
  bg: 'primary',
  pill: false
};
const Badge = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  bg,
  pill,
  text,
  className,
  as: Component = 'span',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'badge');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
  });
});
Badge.displayName = 'Badge';
Badge.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["Z"] = (Badge);

/***/ }),

/***/ 51351:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _throw; }
/* harmony export */ });
function _throw(e) {
    throw e;
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,959,1387,3564,3278,9774,2888,179], function() { return __webpack_exec__(26447); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);